<style scoped>
::v-deep .modal-window {
    border-radius: 2rem !important;
}

.img-ar {
    width: 100%;
    position: relative;
    overflow: hidden;
    padding-bottom: calc(100 / (1042 / 834) * 1px);
}
.img-ar > img {
    position: absolute;
    top: 50%;
    left: 50%;
    max-height: 100%;
    max-width: 100%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.modal-content-wrapper {
    height: 70vh;
    @apply flex flex-col items-center mb-12;
}
</style>

<template>
    <div>
        <button @click="showModal = true" :class="btnClass">
            {{ $t(msg) }}
        </button>
        <modal
            v-if="showModal"
            type="custom"
            :showDismiss="true"
            class="modal-3xl"
            @backdrop="showModal = false"
        >
            <div class="modal-content-wrapper">
                <div class="img-ar flex-1">
                    <img :src="img" />
                </div>
                <br />

                <div class="flex flex-col mx-auto items-center ">
                    <loadingButton
                        :status="submitEnquiryStatus"
                        @click="submitEnquiry"
                        class="btn bg-primary mt-2"
                    >
                        {{ '我要成為企業會員' }}
                    </loadingButton>
                    <errorBox
                        class="text-sm text-red"
                        :message="errors.server"
                    />
                    <div
                        v-if="submitEnquiryStatus === 'success'"
                        class=" text-green"
                    >
                        已提申請，我哋會儘快聯絡您。
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import modal from './modal.vue';
import loadingButton from './loadingButton.vue';
import errorBox from './errorBox.vue';
import imgBecomeEnterpriseMember_friends from '../assets/img/become_enterprise_member_friends.jpg';
import imgBecomeEnterpriseMember_public from '../assets/img/become_enterprise_member_public.jpg';
import { instance } from '@/utils/ajax';

async function applyEnterprise() {
    try {
        let result = await instance.post('/api/enq/applyEnterprise');
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error apply enterprise');
        return { success: false, all: 'error.connect' };
    }
}

export default {
    components: {
        modal,
        loadingButton,
        errorBox
    },
    props: {
        msg: { type: String, default: '成為企業會員' },
        btnClass: { type: String }
    },
    data() {
        const isFriendCustomer = this.$store.getters.isFriendCustomer;
        return {
            showModal: false,
            errors: {},
            submitEnquiryStatus: undefined,
            img: isFriendCustomer
                ? imgBecomeEnterpriseMember_friends
                : imgBecomeEnterpriseMember_public
        };
    },
    created() {
        this.$watch('showModal', function() {
            this.submitEnquiryStatus = undefined;
        });
    },
    methods: {
        async submitEnquiry() {
            this.errors = {};

            this.submitEnquiryStatus = 'loading';
            const result = await applyEnterprise();

            if (result.success) {
                this.submitEnquiryStatus = 'success';
            } else {
                this.submitEnquiryStatus = undefined;
                if (result.data.errors) {
                    this.errors = result.data.errors;
                }
            }
        }
    }
};
</script>
